export const ABOUT_ANCHOR = 'about';
export const REMOTE_ANCHOR = 'remote';
